import { Outlet } from "react-router-dom";

export default () => {
  return (
        <Outlet/>
  );
}
